import { ILoanSummaryDashboardOutstandingLoanTypeSummary } from '@apply/api/src/api/loanApi';
import { ILoanTypeOutstandingTotals } from '../interfaces/ILoanTypeOutstandingTotals';

export function outstandingLoanTypeTotals(
    dataSource: ILoanSummaryDashboardOutstandingLoanTypeSummary[] | undefined
): ILoanTypeOutstandingTotals {
    if (!dataSource) {
        return { committed: 0, funded: 0, number: 0 };
    }

    return dataSource.reduce(
        (acc, row) => ({
            committed: acc.committed + (row.committedAmount ?? 0),
            funded: acc.funded + (row.fundedAmount ?? 0),
            number: acc.number + (row.number ?? 0),
        }),
        { committed: 0, funded: 0, number: 0 }
    );
}
